import './index.scss';
import React, { useEffect, useState, useRef } from 'react';
import { ListView, Icon, NavBar, PullToRefresh, Toast, Modal } from 'antd-mobile';
import { getBooleanValue } from '@/utils';
import { list } from '../../services/saas/active';
import { getApp, getDefaultCover, getPageQuery, getUser, toConference } from '../../utils';
import moment from 'moment';
import { useHistory } from 'react-router';
import sysConfig from '@/sysConfig';
import ShowEmpty from '@/components/showEmpty';
import { authority } from '../../services/saas/active';

const { preRouteUrl } = sysConfig;
const { live: defaultActiveCover } = getDefaultCover();
const Alert = Modal.alert;

function ListWrap(props) {
  return <div className="studioInteract-list">{props.children}</div>;
}
function StudioInteractMore() {
  const { studioId: sourceId, sourceApp, type } = getPageQuery();
  const headers = [
    { key: 'hdlb', value: '活动列表', finished: 0 },
    { key: 'hdhk', value: '活动回看', finished: 1 },
  ];
  const [selected, setSelected] = useState(type === '0' ? 'hdlb' : 'hdhk');
  const [finished, setFinished] = useState(type ? parseInt(type) : 0);

  const [hasMore, setHasMore] = useState(false);
  let [pageIndex, setIndex] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [draging, setDraging] = useState(false);
  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSouce] = useState(dataS);

  const { appId } = getApp();
  const getStudioInteract = async (page) => {
    await setLoading(true);
    const params = {
      current: page || 1,
      size: 4,
      releaseStatus: 1,
      sourceId: sourceId,
      sourceApp: sourceApp || appId,
      finished: finished,
      sortField: finished === 1 ? '' : 'asc',
    };
    const response = await list(params);
    if (response.success && response.data.records) {
      const studioInteractList = (page === 1 ? [] : data).concat(response.data.records);
      setDraging(false);
      setLoading(false);
      setData(studioInteractList);
      setDataSouce(dataSource.cloneWithRows(studioInteractList));
      setHasMore(response.data.current < response.data.pages);
      setIndex(page);
    }
  };

  useEffect(() => {
    getStudioInteract(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  const onEndReached = function () {
    if (!loading && hasMore) {
      getStudioInteract(++pageIndex);
    }
  };

  const listRef = useRef();
  const row = (rowData, sectionID, rowID) => {
    const {
      id,
      startTime,
      endTime,
      lessonProgressStatus,
      coverUrl,
      lessonName,
      signNum,
      replayable,
    } = rowData;
    return (
      <div className="studioInteract-list-item" key={rowID}>
        <StudioInteractItem
          key={id}
          id={id}
          finished={finished}
          time={moment(startTime).format('kk:mm')}
          date={moment(startTime).format('YYYY-MM-DD')}
          status={lessonProgressStatus}
          cover={coverUrl}
          name={lessonName}
          duration={moment(endTime).diff(startTime)}
          signNum={signNum}
          replayable={replayable}
        />
      </div>
    );
  };

  return (
    <div className={`studioInteractMore${getBooleanValue('IS_IMMERSE', false) ? ' immerse' : ''}`}>
      <NavBar mode="light" icon={<Icon type="left" />} onLeftClick={() => window.history.go(-1)}>
        <span>教研活动</span>
      </NavBar>
      <div className="content">
        <div className="headers">
          {headers.map((item) => (
            <span
              className={`header${selected === item.key ? ' selected' : ''}`}
              key={item.key}
              onClick={() => {
                setSelected(item.key);
                setFinished(item.finished);
              }}
            >
              {item.value}
            </span>
          ))}
        </div>
        {data.length > 0 ? (
          <ListView
            ref={listRef}
            dataSource={dataSource}
            renderHeader={false}
            renderFooter={() => (
              <div style={{ padding: 10, textAlign: 'center' }}>
                {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
              </div>
            )}
            renderBodyComponent={() => <ListWrap />}
            renderRow={row}
            className="studioInteract-list-wrap"
            pageSize={5}
            onScroll={() => {
              console.log('scroll');
            }}
            scrollRenderAheadDistance={500}
            onEndReached={onEndReached}
            onEndReachedThreshold={10}
            pullToRefresh={
              <PullToRefresh
                refreshing={draging}
                onRefresh={() => {
                  setDraging(true);
                  getStudioInteract(1);
                }}
              />
            }
          />
        ) : (
          // <div className="list">
          //   {data.map((item) => (
          //     <StudioInteractItem
          //       key={item.id}
          //       id={item.id}
          //       time={moment(item.startTime).format('kk:mm')}
          //       date={moment(item.startTime).format('YYYY-MM-DD')}
          //       status={item.lessonProgressStatus}
          //       cover={item.coverUrl}
          //       name={item.lessonName}
          //       duration={moment(item.endTime).diff(item.startTime)}
          //       signNum={item.signNum}
          //       replayable={item.replayable}
          //     />
          //   ))}
          // </div>
          <ShowEmpty />
        )}
      </div>
    </div>
  );
}

const StudioInteractItem = (props) => {
  const statusMapper = new Map([
    ['0', { text: '即将开始', className: 'will' }],
    ['1', { text: '进行中', className: 'ing' }],
    ['2', { text: '已结束', className: 'end' }],
  ]);

  const forwordTo = async (id, status) => {
    if (status === '0') {
      Toast.info('尚未开始');
      return;
    }
    if (status === '2') {
      Toast.info('已结束');
      return;
    }
    if (status === '1') {
      const { userId } = getUser();
      const confirm = (text) => {
        Alert('是否进入直播', text, [
          { text: '取消', onPress: null },
          { text: '确定', onPress: () => history.push(`${preRouteUrl}/livePlay/lesson/${id}`) },
        ]);
      };
      try {
        const resp = await authority({ lessonId: id, userId });
        if (resp.success && resp.data) {
          const result = resp.data;
          if (result.permission === 1) {
            if (!result.isFull || result.userInfo.role === '4') {
              if (
                (result.conferenceInfo && result.conferenceInfo.isLocked === 0) ||
                result.userInfo.role === '4'
              ) {
                toConference(result);
              } else {
                confirm('会议已锁定，是否进入直播？');
              }
            } else {
              confirm('参与人数已达到上限，是否进入直播？');
            }
          } else {
            Toast.info('无参与权限！');
          }
        }
      } catch (err) {
        Toast.info(err);
      }
    }
  };

  const { id, time, finished, date, status, cover, name, duration, signNum, replayable } = props;
  const history = useHistory();

  return (
    <div className="studioInteractItem">
      <div className="head">
        <div className="time">{time}</div>
        <div className="date">{date}</div>
        {status && (
          <div className={`status ${statusMapper.get(status).className}`}>
            {statusMapper.get(status).text}
          </div>
        )}
      </div>
      <div
        className="box"
        onClick={() => {
          if (finished) {
            if (replayable) {
              history.push(`${preRouteUrl}/livePlayback/lesson/${id}`);
            }
          } else {
            forwordTo(id, status);
          }
        }}
      >
        <div className="cover">
          <img src={cover || defaultActiveCover} alt="" />
        </div>
        <div className="right">
          <div>
            <div className="name textOverflow">{name}</div>
            {replayable ? <div className="view">查看活动</div> : undefined}
          </div>
          <div className="duration">
            <span className="time textOverflow">
              时长：{duration && (duration / 1000 / 60 / 60).toFixed(2)}小时
            </span>
          </div>
          <div className="attendance textOverflow">{signNum}</div>
        </div>
      </div>
    </div>
  );
};

export default StudioInteractMore;
